import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsStore } from '../../../state/user-settings.repository';
import { Button } from '../../../shared/components/ui/buttons/gradient-btn/button';

@Component({
  selector: 'andor-show-promo',
  standalone: true,
  imports: [CommonModule, TranslatePipe, Button],
  templateUrl: './show-promo.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './show-promo.scss',
})
export class ShowPromo {
  constructor(public userSettingsStore: UserSettingsStore) {}
}
